import { faBars, faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { setUserInteractionDataAttribute } from "@shared/constants";

interface Props {
  ariaControls?: string;
  id?: string;
  isAriaHidden: boolean;
  isNavExpanded: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export default function Toggle({
  ariaControls,
  id,
  isAriaHidden,
  isNavExpanded,
  onClick,
}: Props) {
  return (
    <button
      {...setUserInteractionDataAttribute(
        `navigation-menu_toggle_button_${isNavExpanded ? "expanded" : "closed"}`,
      )}
      className={`site-header__nav__toggle site-header__nav__toggle--${isNavExpanded ? "expanded" : "closed"}`}
      aria-controls={ariaControls || "main-navigation"}
      aria-expanded={isNavExpanded}
      aria-haspopup="menu"
      aria-hidden={isAriaHidden}
      aria-label={(isNavExpanded ? "Hide" : "Show") + " navigation menu"}
      id={id || "main-navigation-toggle"}
      onClick={onClick}
    >
      <div className="site-header__nav__toggle__content">
        <FontAwesomeIcon icon={isNavExpanded ? faXmark : faBars} />
        <div className="site-header__nav__toggle__content__text">Menu</div>
      </div>
    </button>
  );
}
